import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import { Link } from "react-router-dom";

const FAQ = [
  {
    q: "Is Link a rideshare app?",
    a: "No. Link is a pre-scheduled, recurring round-trip transportation plan. You set the route once and we run it on the days you choose — no surge, no on-demand booking, no guesswork.",
  },
  {
    q: "How is pricing calculated?",
    a: "Your daily rate is based on your route distance, and your weekly total drops the more days a week you ride. You'll see the exact price for your route when you enter your pickup and drop-off — no surge, no per-ride fees.",
  },
  {
    q: "Can I pay for a single trip instead of a weekly plan?",
    a: "Yes. When you confirm a route you can pick One-time (a single round-trip charge) or Weekly (recurring). Switching between the two is just a tap inside the booking surface.",
  },
  {
    q: "What service area do you cover?",
    a: "Up to 50 miles one-way from your pickup. Routes outside that range surface an Out-of-range card and aren't bookable today — contact us for special arrangements.",
  },
  {
    q: "How do I change my route or skip a day?",
    a: "From your Account → Trips you can adjust upcoming pickup times, edit your weekly schedule, or cancel an upcoming trip. Subscriptions can be paused or cancelled anytime from the Stripe billing portal.",
  },
  {
    q: "How do drivers find me?",
    a: "Once a driver is assigned to your trip, you'll see a live mini-map on your Trips screen with status updates: En route → Arriving now → Picked up → Completed. Locations refresh every few seconds.",
  },
];

export default function FAQs() {
  const [open, setOpen] = useState(0);

  return (
    <main className="min-h-screen bg-[#F9F7F4] pb-32" data-testid="faqs-page">
      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-12 pt-12 pb-10">
        <div className="label-xs text-[#ed6500] mb-3">Frequently asked</div>
        <h1 className="font-serif text-4xl sm:text-5xl text-[#0A1128] tracking-tight">
          Questions, answered.
        </h1>
        <p className="mt-3 text-[#515E7B] text-sm sm:text-base max-w-prose">
          Everything you'd want to know before you set up a route. Still curious? See the{" "}
          <Link to="/about" className="text-[#ed6500] underline-offset-4 hover:underline">About</Link>{" "}
          page or{" "}
          <Link to="/policies" className="text-[#ed6500] underline-offset-4 hover:underline">Policies</Link>.
        </p>
      </section>

      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="divide-y hairline border-t border-b hairline" data-testid="faqs-list">
          {FAQ.map((item, i) => {
            const expanded = open === i;
            return (
              <div key={i} data-testid={`faqs-item-${i}`}>
                <button
                  type="button"
                  onClick={() => setOpen(expanded ? -1 : i)}
                  className="w-full flex items-center justify-between py-5 text-left group"
                  aria-expanded={expanded}
                >
                  <span className="font-serif text-lg sm:text-xl text-[#0A1128] pr-6">
                    {item.q}
                  </span>
                  <ChevronDown
                    size={20}
                    strokeWidth={1.8}
                    className="text-[#0A1128] shrink-0 transition-transform duration-200"
                    style={{ transform: expanded ? "rotate(180deg)" : "rotate(0)" }}
                  />
                </button>
                <div
                  className="overflow-hidden transition-[max-height,opacity] duration-300 ease-out"
                  style={{
                    maxHeight: expanded ? 240 : 0,
                    opacity: expanded ? 1 : 0,
                  }}
                >
                  <p className="text-[#515E7B] text-sm sm:text-base leading-relaxed pb-5 pr-10">
                    {item.a}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </main>
  );
}
